var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 31.168a1.417 1.417 0 01-1.417-1.417v-4.25h-8.5a4.255 4.255 0 01-4.25-4.25V7.084a4.255 4.255 0 014.25-4.25h19.833a4.255 4.255 0 014.25 4.25v14.167a4.255 4.255 0 01-4.25 4.25H15.583a1.416 1.416 0 110-2.833h11.333a1.418 1.418 0 001.417-1.417V7.084a1.418 1.418 0 00-1.417-1.416H7.083a1.418 1.418 0 00-1.417 1.416v14.167a1.418 1.418 0 001.417 1.417H17a1.417 1.417 0 011.416 1.416v5.667A1.417 1.417 0 0117 31.168z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.25 31.166h-8.5a1.417 1.417 0 110-2.833h8.5a1.417 1.417 0 010 2.833zM17 21.249a1.404 1.404 0 01-1.417-1.417 1.417 1.417 0 112.833 0A1.404 1.404 0 0117 21.249z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.35c146f9161e0aec8c527a613ea8699d.svg";
export { ForwardRef as ReactComponent };